import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../config/URL";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  ThemeProvider,
  createTheme,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import GlobalDelete from "../../components/common/GlobalDelete";
import { exportVisibleColumnsToCSV } from "../../components/common/ExportCsv";
import {
  getColumnPreference,
  saveColumnPreference,
} from "../../utility/mrtColumnPersistence";

const MODULE_KEY = "TEACHER";

const Teacher = ({ selectedCenter }) => {
  const [filters, setFilters] = useState({
    centerId: selectedCenter,
    teacherName: "",
    country: "",
    teacherType: "",
    status: "",
  });

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const roles = localStorage.getItem("userName");
  const storedScreens = JSON.parse(localStorage.getItem("screens") || {});
  const canIndex = Boolean(storedScreens?.teacherIndex);
  const canRead = Boolean(storedScreens?.teacherRead);
  const canCreate = Boolean(storedScreens?.teacherCreate);
  const canUpdate = Boolean(storedScreens?.teacherUpdate);
  const canDelete = Boolean(storedScreens?.teacherDelete);
  const showActionColumn = canUpdate || canDelete;
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const defaultColumnVisibility = {
    createdBy: false,
    updatedBy: false,
  };

  const [columnVisibility, setColumnVisibility] = useState(() =>
    getColumnPreference(MODULE_KEY, defaultColumnVisibility),
  );
  /* -------------------- COLUMNS -------------------- */
  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorFn: (row, index) => index + 1,
        header: "S.NO",
        size: 40,
        Cell: ({ cell }) => (
          <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "role",
        enableHiding: true,
        header: "Role",
        Cell: ({ row }) =>
          row.original.role === "Teacher" ||
          row.original.role === "teacher" ||
          row.original.role === "TEACHER" ? (
            <span className="badge badges-Green fw-light">Teacher</span>
          ) : row.original.role === "freelancer" ||
            row.original.role === "free_lancer" ||
            row.original.role === "FREELANCER" ? (
            <span className="badge badges-orange fw-light">Freelancer</span>
          ) : null,
      },
      { accessorKey: "teacherName", header: "Teacher Name" },
      { accessorKey: "userUniqueId", header: "Teacher Id" },
      { accessorKey: "countryName", header: "Country" },
      { accessorKey: "teacherType", header: "Teacher Type" },
      { accessorKey: "email", header: "Email" },
      { accessorKey: "contactNumber", header: "Mobile" },
      {
        accessorKey: "createdAt",
        header: "Created On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10),
      },
      {
        accessorKey: "updatedAt",
        header: "Updated On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10) || "",
      },
      { accessorKey: "createdBy", header: "Created By" },
      { accessorKey: "updatedBy", header: "Updated By" },
    ];

    if (!showActionColumn) return baseColumns;

    const actionColumn = {
      id: "actions",
      header: "",
      size: 20,
      enableSorting: false,
      Cell: ({ row }) => (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setMenuAnchor(e.currentTarget);
            setSelectedId(row.original.id);
          }}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    };

    // ✅ Action column ALWAYS second
    return [baseColumns[0], actionColumn, ...baseColumns.slice(1)];
  }, [showActionColumn]);

  /* -------------------- FETCH DATA -------------------- */
  // const fetchData = async () => {
  //   try {
  //     let response;

  //     if (roles === "SMS_ADMIN") {
  //       response = await api.get("/getAllTeachersAndFreelancers");
  //     } else if (roles === "SMS_TEACHER") {
  //       response = await api.get("/getAllUsersByRole/teacher");
  //     } else if (roles === "SMS_FREELANCER") {
  //       response = await api.get("/getAllFreelance");
  //     }

  //     if (response) {
  //       setData(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchData = async () => {
    try {
      setLoading(true);
      // Remove empty filters and create query string
      const queryParams = new URLSearchParams();
      filters.centerId = selectedCenter;
      for (let key in filters) {
        if (filters[key]) {
          queryParams.append(key, filters[key]);
        }
      }

      const baseUrl =
        selectedCenter === 0 || selectedCenter === "0"
          ? "getAllTeachersAndFreelancers"
          : "getAllTeachersAndFreelancers";
      // ? `getAllTeachersAndFreelancers`
      // : `/getAllTeachersAndFreelancers?centerId=${selectedCenter}`;
      queryParams.centerId = selectedCenter;
      const url = queryParams ? `${baseUrl}?${queryParams}` : baseUrl;

      const response = await api.get(url);
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data ", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filters, selectedCenter]);
  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     let response;

  //     if (filters.centerId === 0) {
  //       response = await api.get("/getAllTeachersAndFreelancers");
  //     } else {
  //       const filteredFilters = Object.fromEntries(
  //         Object.entries(filters).filter(
  //           ([key, value]) =>
  //             value !== "" && value !== null && value !== undefined
  //         )
  //       );
  //       if (filteredFilters.centerId === 0) {
  //         delete filteredFilters.centerId;
  //       }
  //       const queryParams = new URLSearchParams(filteredFilters).toString();
  //       console.log("Filters:", filteredFilters);
  //       console.log("Query Params:", queryParams);
  //       response = await api.get(
  //         `/getAllTeachersAndFreelancers${queryParams ? `?${queryParams}` : ""}`
  //       );
  //     }

  //     setData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  /* -------------------- THEME -------------------- */
  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
    },
  });

  /* -------------------- FILTER HANDLERS -------------------- */
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const clearFilter = () => {
    setFilters({
      centerId: selectedCenter,
      teacherName: "",
      country: "",
      teacherType: "",
      status: "",
    });
  };

  // const filteredData = useMemo(() => {
  //   return data.filter((item) => {
  //     const matchesTeacherName = item.teacherName
  //       ?.toLowerCase()
  //       .includes(filters.teacherName.toLowerCase());
  //     const matchesEmail = item.country
  //       ?.toLowerCase()
  //       .includes(filters.country.toLowerCase());

  //     return (
  //       (filters.teacherName ? matchesTeacherName : true) &&
  //       (filters.country ? matchesEmail : true)
  //     );
  //   });
  // }, [data, filters]);

  const handleMenuClose = () => setMenuAnchor(null);

  /* -------------------- TABLE INSTANCE -------------------- */
  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      columnVisibility,
    },
    onColumnVisibilityChange: (updater) => {
      const newVisibility =
        typeof updater === "function" ? updater(columnVisibility) : updater;

      setColumnVisibility(newVisibility);
      saveColumnPreference(MODULE_KEY, newVisibility);
    },
    enableColumnActions: true,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    initialState: {
      pagination: { pageSize: 50, pageIndex: 0 },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <button
        className="btn btn-sm btn-border"
        onClick={() =>
          exportVisibleColumnsToCSV(table, data, "TeacherList.csv")
        }
      >
        Export CSV
      </button>
    ),
    muiTableBodyRowProps: ({ row }) => ({
      onClick: canRead
        ? () => navigate(`/teacher/view/${row.original.id}`)
        : undefined,
      style: { cursor: canRead ? "pointer" : "default" },
    }),
  });

  return (
    <div className="container-fluid center my-4">
      <ol
        className="breadcrumb my-3"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          &nbsp;Staffing
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="active breadcrumb-item" aria-current="page">
          &nbsp;Teacher
        </li>
      </ol>
      <div className="card">
        <div
          className="d-flex align-items-center justify-content-between p-1 mb-3"
          style={{ background: "#f5f7f9" }}
        >
          <div className="d-flex align-items-center">
            <div className="d-flex">
              <div className="active dot"></div>
            </div>
            <span className="text-muted me-2">
              This database shows the list of{" "}
              <span className="bold" style={{ color: "#287f71" }}>
                Teacher
              </span>
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-lg-flex individual_fliters">
            <input type="hidden" name="centerId" value={filters.centerId} />

            <div className="form-group mb-0 mb-1 ms-2">
              <input
                type="text"
                name="teacherName"
                className="form-control form-control-sm center_list"
                style={{ width: "160px" }}
                placeholder="Teacher Name"
                value={filters.teacherName}
                onChange={handleFilterChange}
              />
            </div>
            <div className="form-group mb-0 mb-1 ms-2">
              <input
                type="text"
                name="country"
                className="form-control form-control-sm center_list"
                style={{ width: "160px" }}
                placeholder="Country"
                value={filters.country}
                onChange={handleFilterChange}
              />
            </div>
            <div className="form-group mb-0 mb-1 ms-2">
              <select
                type="text"
                className="form-select form-select-sm center_list"
                style={{ width: "160px" }}
                name="teacherType"
                value={filters.teacherType}
                onChange={handleFilterChange}
              >
                <option value="" selected>
                  Select Teacher Type
                </option>
                <option value="Permanent">Permanent</option>
                <option value="Temporary">Temporary</option>
                <option value="Intern">Intern</option>
              </select>
            </div>
            <div className="form-group mb-0 mb-1 ms-2">
              <select
                type="text"
                className="form-select form-select-sm center_list"
                style={{ width: "160px" }}
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="" selected>
                  Select a status
                </option>
                <option value={"ACTIVE"}>Active</option>
                <option value={"RESIGNED"}>Resigned</option>
              </select>
            </div>

            <div className="form-group mb-0 mb-1 ms-2">
              <button
                type="button"
                className="btn btn-border btn-sm"
                onClick={clearFilter}
              >
                Clear
              </button>
            </div>
          </div>
          {canCreate && (
            <Link to="/teacher/add">
              <button
                type="button"
                className="btn btn-button btn-sm me-2"
                style={{ fontWeight: "600px !important" }}
              >
                &nbsp; Add &nbsp;&nbsp; <i className="bx bx-plus"></i>
              </button>
            </Link>
          )}
        </div>
        {loading ? (
          <div className="loader-container">
            <div className="loading">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <>
            <ThemeProvider theme={theme}>
              <MaterialReactTable table={table} />
            </ThemeProvider>

            <Menu
              id="action-menu"
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              {canUpdate && (
                <MenuItem
                  onClick={() => navigate(`/teacher/edit/${selectedId}`)}
                  className="text-start mb-0 menuitem-style"
                >
                  Edit
                </MenuItem>
              )}

              {canDelete && (
                <MenuItem>
                  <GlobalDelete
                    path={`/deleteUser/${selectedId}`}
                    onDeleteSuccess={fetchData}
                    onOpen={handleMenuClose}
                  />
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </div>
    </div>
  );
};

export default Teacher;
